export const COMPARE_FILTER_HISTORY = 'COMPARE_FILTER_HISTORY'
export const COMPARE_FILTER_HISTORY_ERR = 'COMPARE_FILTER_HISTORY_ERR'
export const RESET_COMPARE_FILTER_HISTORY = 'RESET_COMPARE_FILTER_HISTORY'